import styled from 'styled-components';

export const AudioPlayer = styled.audio`
  z-index: 50;
  right: 10px;
  bottom: 10px;
  position: fixed;
  width: 100px;

  @media screen and (max-width: 960px) {
    display: none;
  }

`